module.exports = __webpack_public_path__ + "img/LaC_logo_duo_light_4.48ac4ed2.svg";